import { Card, Inline, vars, Text } from '@etg/wings';
import { Icon } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';

const cardStyles = css`
  border: 1px solid ${vars.colors.divider};
`;

const iconStyles = css`
  flex: 0 0 auto;
`;

const CheckedBaggageSelfTransferCard = () => {
  const { t } = useTranslation();

  return (
    <Card className={cardStyles}>
      <Inline alignY="top" noWrap spacing={8}>
        <Icon
          aria-hidden
          className={iconStyles}
          color={vars.colors.promotional.foreground}
          id="self-transfer"
          size="20px"
        />
        <Text>{t('IbeClient.Itinerary.Drawer.BaggageInformation.SelfTransfer.Card.Text')}</Text>
      </Inline>
    </Card>
  );
};

export default CheckedBaggageSelfTransferCard;
